import axios, { AxiosResponse } from 'axios'
import { Marketplace } from '@/shared/enums/marketplace'

export default class MarketPlaceUserService {
  getUserInfo (marketPlace: Marketplace, userId: string): Promise<AxiosResponse> {
    return axios.get(`api/marketplaces/${marketPlace}/users/${userId}`)
  }

  getCounters (marketPlace: Marketplace, userId: string): Promise<AxiosResponse> {
    return axios.get(`api/marketplaces/${marketPlace}/users/${userId}/counters`)
  }

  getBlocked (marketPlace: Marketplace, userId: string): Promise<AxiosResponse> {
    return axios.get(`api/marketplaces/${marketPlace}/users/${userId}/blocked`)
  }

  postUnblock (marketPlace: Marketplace, userId: string, partnersIds: string[]): Promise<AxiosResponse> {
    return axios.post(`api/marketplaces/${marketPlace}/users/${userId}/unblock`, partnersIds)
  }

  resetCounters (marketPlace: Marketplace, userId: string): Promise<AxiosResponse> {
    return axios.delete(`api/marketplaces/${marketPlace}/users/${userId}/counters`)
  }
}
